/*
 * Copyright 2026 Sony Corporation
 */

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';

export interface PanelSectionProps {
  title: string;
  /** Sections a user reaches for first open on arrival; the rest stay shut. */
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

/** A collapsible block in a side panel, so a panel opens as a list of what it holds. */
export const PanelSection = ({ title, defaultExpanded, children }: PanelSectionProps) => (
  <Accordion disableGutters square elevation={0} defaultExpanded={defaultExpanded} className="before:hidden">
    <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />} className="px-0">
      <Typography variant="subtitle2">{title}</Typography>
    </AccordionSummary>
    <AccordionDetails className="px-0 pt-0">{children}</AccordionDetails>
  </Accordion>
);
